import AsyncSelect, { Option } from "@/components/AsyncSelect";
import { EntityListLink } from "@/components/EntityListLink";
import { Module } from "@/constants";
import { fetchPayrollDepartmentList } from "@/services/payrollDepartmentsService";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import { useTranslation } from "react-i18next";
import appConfiguration from "@/components/cfg/AppCfg";

interface PayrollDepartmentSelectProps extends ControllerRenderProps {
  className?: string;
  inDialog?: boolean;
  showEntityLink?: boolean;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, PayrollDepartmentSelectProps>(
  function PayrollDepartmentSelect(
    { value, inDialog, showEntityLink = true, defaultItem, ...props },
    ref,
  ) {
    const { t } = useTranslation();

    return (
      <span className="flex items-center gap-1">
        <AsyncSelect
          queryKey={[Module.PayrollDepartments]}
          queryFn={() =>
            fetchPayrollDepartmentList({
              limit: appConfiguration.selectComponentsPaginationLimit,
            })
          }
          placeholder={t("payrollDepartmentSelect.placeholder")}
          loadingLabel={t("payrollDepartmentSelect.loadingDepartments")}
          {...props}
          value={value ? value.toString() : undefined}
          ref={ref}
          enableFilter={false}
          inDialog={inDialog}
          defaultItem={defaultItem}
        />
        {showEntityLink && (
          <EntityListLink
            path={Module.PayrollDepartments}
            label={t("payrollDepartmentSelect.link")}
          />
        )}
      </span>
    );
  },
);
